<template>
    <div class="form_group_container">
        <template v-for="field_name in available_fields" :key="field_name">
        <div class="form_row_container form_multi_column_md form_multi_column_md_2" v-if="current_item_field[field_name] && current_item_field[field_name].validate_type != null && current_item_field[field_name].validate_type.indexOf('repeat')>=0" v-show="show_input(field_name)">
            <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'">
                <label :for="module_name+'_'+field_name" v-html="field_label(field_name)" v-show="show_label(field_name)"></label>
                <textarea v-if="current_item_field[field_name].field_type === 'textarea'" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change(field_name)"></textarea>
                <input v-else :type="current_item_field[field_name].field_type" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change(field_name)">
            </div>
            <div class="form_row" :class="'form_row_'+current_item_field['_repeat_'+field_name].field_type+'_container'">
                <label :for="module_name+'_repeat_'+field_name" v-html="field_label('_repeat_'+field_name)" v-show="show_label('_repeat_'+field_name)"></label>
                <textarea v-if="current_item_field['_repeat_'+field_name].field_type === 'textarea'" :id="module_name+'_repeat_'+field_name" :name="'_repeat_'+field_name" v-model="cache_data['_repeat_'+field_name]" :placeholder="field_label('_repeat_'+field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change('_repeat_'+field_name)"></textarea>
                <input v-else :type="current_item_field['_repeat_'+field_name].field_type" :id="module_name+'_repeat_'+field_name" :name="'_repeat_'+field_name" v-model="cache_data['_repeat_'+field_name]" :placeholder="field_label('_repeat_'+field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change('_repeat_'+field_name)">
            </div>
        </div>
        <div class="form_row" v-else-if="current_item_field[field_name].validate_type.indexOf('null_flag')>=0" v-show="show_input(field_name)">
            <div class="form_row" :class="'form_row_checkbox_container'">
                <label :for="module_name+'_flag_'+field_name" v-html="field_label('_flag_'+field_name)"></label>
                <input type="checkbox" :id="module_name+'_flag_'+field_name" :name="'_flag_'+field_name" v-model="cache_data['_flag_'+field_name]" @change="!cache_data['_flag_'+field_name] && field_change(field_name,'')">
            </div>
            <div class="form_row" :class="'form_row_date_container'" v-show="cache_data['_flag_'+field_name]">
                <label :for="module_name+'_'+field_name" v-html="field_label(field_name)" v-show="show_label(field_name)"></label>
                <span v-show="current_item_field[field_name].field_prefix" v-html="current_item_field[field_name].field_prefix"></span>
                <input :type="current_item_field[field_name].field_type" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" @change="field_change(field_name)">
                <span v-show="current_item_field[field_name].field_postfix" v-html="current_item_field[field_name].field_postfix"></span>
            </div>
        </div>
        <div class="form_row" v-else-if="current_item_field[field_name].field_type === 'multi_checkbox'" v-show="show_input(field_name)">
            <label :for="module_name+'_'+field_name" v-html="field_label(field_name)"></label>
            <span v-show="current_item_field[field_name].field_prefix" v-html="current_item_field[field_name].field_prefix"></span>
            <div class="form_row_multi_checkbox_container">
                <div class="form_row_multi_checkbox_container">
                    <div class="svg_checkbox_container"  v-for="field_available_option in field_available_options[field_name]" @click="field_change(field_name,field_available_option.id,{'set_method':'toggle'})">
                            <span class="svg_checkbox_input">
                                <svg viewBox="0 0 10 8" fill="none">
                                    <path v-show="cache_data[field_name].includes(field_available_option.id)" d="M1 4L3.5 6.5L9 1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        <span>{{ field_available_option.name }}</span>
                    </div>
                </div>
            </div>
<!--            <multi-select-checkbox v-model="cache_data[field_name]" :options="current_item_field[field_name].field_available_options" :label="field_label(field_name)" :name="field_name" />-->
            <span v-show="current_item_field[field_name].field_postfix" v-html="current_item_field[field_name].field_postfix"></span>
        </div>
        <div class="form_group form_group_trust_party_list" v-else-if="module_depth_level <= 10 && current_item_field[field_name].field_type === 'sub_item_list'" v-show="show_input(field_name)">
            <div class="form_row">
                <label>{{ field_label(field_name) }}</label>
            </div>
            <div class="form_row form_row_controller_container" v-show="cache_data[field_name].length < current_item_field[field_name].limit.max && !current_chosen[field_name]">
                <input type="button" class="btn btn-primary" value="Add New" @click="current_chosen[field_name] = 'new'" style="font-size: 0.6em;">
            </div>
            <div class="form_row form_row_list_container" v-show="!current_chosen[field_name]">
                <div class="form_row_list" v-for="sub_item_id in cache_data[field_name]">
                    <div>
                        <span class="form_row_list_name">{{ form_root.item_map[current_item_field[field_name].ref_module_name][sub_item_id].formatted_name }}</span>
                        <a class="form_row_list_controller" href="javascript:void(0);" @click="current_chosen[field_name] = sub_item_id"><span class="glyphicon glyphicon-pencil"></span></a>
                        <a class="form_row_list_controller" href="javascript:void(0);" @click="remove_party(sub_item_id,field_name)"><span class="glyphicon glyphicon-trash"></span></a>
                    </div>
                </div>
            </div>
            <update-fte-review-entity v-show="current_chosen[field_name]" :current_id="current_chosen[field_name]" @submit="subform_submit" :option="{module_name:current_item_field[field_name].ref_module_name,field_name_in_parent_form:field_name}"></update-fte-review-entity>
        </div>
        <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'" v-else-if="current_item_field[field_name].field_type === 'image'" v-show="show_input(field_name)">
            <label :for="module_name+'_'+field_name" v-html="field_label(field_name)"></label>
            <a title="Edit" class="glyphicon glyphicon-pencil" href="javascript:void(0);" v-show="!current_chosen[field_name]" @click="current_chosen[field_name] = true"></a>
            <a title="Delete" class="glyphicon glyphicon-trash" href="javascript:void(0);" v-show="!current_chosen[field_name] && cache_data[field_name] && cache_data[field_name] !== 'deleted'" @click="cache_data[field_name] = 'deleted'"></a>
            <div class="form_static_value" v-show="!current_chosen[field_name]">
                <img v-if="cache_data[field_name] && cache_data[field_name] !== 'deleted'" :src="cache_data[field_name]">
                <div v-else-if="cache_data[field_name] === 'deleted'">Thumb is going to be deleted on form submission</div>
                <div v-else>Thumb Not Available</div>
            </div>
            <update-image v-show="current_chosen[field_name]" :option="current_item_field[field_name].editor_option" @submit="subform_submit"></update-image>
        </div>
        <div class="form_row" v-else-if="current_item_field[field_name].field_type === 'address'" v-show="show_input(field_name)">
            <label :for="module_name+'_'+field_name" v-html="field_label(field_name)"></label>
            <a title="Edit" class="glyphicon glyphicon-pencil" href="javascript:void(0);" v-show="!current_chosen[field_name]" @click="current_chosen[field_name] = true"></a>
            <div class="form_static_value" v-show="!current_chosen[field_name]" v-html="formatted_field_value(field_name)"></div>
            <update-address v-show="current_chosen[field_name]" :option="{item_list:item_list,item_map:form_root.item_map,address_name:field_name}" v-on:update:new_address="subform_submit"></update-address>
        </div>
        <input disabled type="hidden" :id="module_name+'_'+field_name" :name="field_name" :value="cache_data[field_name]" v-else-if="current_item_field[field_name].field_type === 'hidden'">
        <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'" v-else v-show="show_input(field_name)">
            <label :for="module_name+'_'+field_name" v-html="field_label(field_name)" v-show="show_label(field_name)"></label>
            <span v-show="current_item_field[field_name].field_prefix" v-html="current_item_field[field_name].field_prefix"></span>
            <textarea v-if="current_item_field[field_name].field_type === 'textarea'" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change(field_name)"></textarea>
            <div v-else-if="current_item_field[field_name].field_type === 'select'" class="select_container">
                <select :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change(field_name)">
                    <option v-if="typeof current_item_field[field_name].empty_value !== 'undefined'" :value="current_item_field[field_name].empty_value" v-show="cache_data[field_name] === current_item_field[field_name].empty_value || mandatory_fields.indexOf(field_name) === -1" v-html="cache_data[field_name] === current_item_field[field_name].empty_value?field_label(field_name, 'select_default'):'-- Unselected --'"></option>
                    <option v-else value="" v-show="cache_data[field_name] === '' || mandatory_fields.indexOf(field_name) === -1" v-html="cache_data[field_name] === ''?field_label(field_name, 'select_default'):'-- Unselected --'"></option>
                    <option :value="field_available_option.id" v-for="field_available_option in current_item_field[field_name].field_available_options">{{ field_available_option.name }}</option>
                </select>
            </div>
            <span v-else-if="current_item_field[field_name].field_type === 'static'" class="form_static_value" v-bind="current_item_field[field_name].field_attributes" v-html="formatted_field_value(field_name)"></span>
            <input v-else-if="current_item_field[field_name].field_type === 'file'" :type="current_item_field[field_name].field_type" :id="module_name+'_'+field_name" :name="field_name" :ref="field_name" :placeholder="field_label(field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change(field_name)">
            <input v-else :type="current_item_field[field_name].field_type" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" v-bind="current_item_field[field_name].field_attributes" @change="field_change(field_name)">
            <span v-show="current_item_field[field_name].field_postfix" v-html="current_item_field[field_name].field_postfix"></span>
        </div>
        </template>
        <div class="form_row form_row_submission_button_container" v-show="get_current_chosen().length < 1 && component_controllers.length">
            <input v-for="component_controller in component_controllers" type="button" v-show="component_controller.show_controller" :class="component_controller.style_class" :value="component_controller.label" @click="component_controller.action">
        </div>
    </div>
</template>

<script>
    export default {
        name: "UpdateFteReviewEntity",
        props: ['option','current_id'],
        data() {
            let data_set = {
                message_option: {
                    message_type: '',
                    message:''
                },
                form_root: null,
                module_depth_level:1,
                module_name:'',
                component_action:'update',
                current_item_field:{},
                field_available_options:{},         // For select, list types of input, init value should come from item_field[field_name].field_available_options

                // edit_field:[],                  // fields that should appear in Form, field_name only, reference to item_field item object
                // confirmation_field:[],          // fields that should appear in confirmation page, field_name only, reference to item_field item object

                // preset_fields:{},

                // available_fields and mandatory_fields are set by get_available_fields() function, should be provided from external script, for example $root in app.js
                // If get_available_fields() has not been defined, all fields in item_field would be available fields and mandatory fields
                available_fields:[],            // function place holder, override from root data init
                mandatory_fields:[],

                current_item_id:0,
                cache_data:{},
                cache_data_label:{},
                current_chosen:{},          // Indicate current chosen value for subform_multi and other similar field_type

                component_controllers:[],
                flag_show_confirmation:false
            };
            let current_object = this;
            console.log('first reset_cache_data');
            current_object.reset_cache_data({data_set:data_set});
            console.log('first reset_cache_data done',data_set);
            return data_set;
        },
        mounted() {
            let current_object = this;
console.log('UpdateFteReviewEntity mounted');
            current_object.reset_cache_data();
        },
        computed: {

        },
        methods: {
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;
                let data_set = current_object;
                if (option.data_set) {
                    data_set = option.data_set;
                }

                // option passed from $parent Vuecomponent
                Object.keys(current_object.option).forEach(function (option_key) {
                    data_set[option_key] = current_object.option[option_key];
                });

                if (!data_set.module_name) {
                    console.log('Error: reset_cache_data key value -> module_name missing');
                    return ;
                }

                if (current_object.$parent) {
                    let parent_object = current_object.$parent;
                    while (parent_object && parent_object !== current_object.$root) {
                        if (parent_object.form_root) {
                            data_set.form_root = parent_object.form_root;
                            if (parent_object.module_depth_level) {
                                data_set.module_depth_level = parent_object.module_depth_level+1;
                            }
                            break;
                        }
                        parent_object = parent_object.$parent;
                    }
                    if (!data_set.form_root) {
                        console.log('Error: reset_cache_data key value -> form_root missing',current_object);
                        data_set.form_root = current_object.$parent;
                        data_set.module_depth_level = 1;
                    }
                    if (!data_set.form_root.item_map[data_set.module_name]) {
                        data_set.form_root.item_map[data_set.module_name] = {};
                    }
                    if (!data_set.form_root.item_list[data_set.module_name]) {
                        data_set.form_root.item_list[data_set.module_name] = [];
                    }
                }
console.log('reset_cache_data data_set',data_set,JSON.stringify(data_set.cache_data));

                // purge cache_data and cache_data_label
                // Object.keys(data_set.cache_data).forEach(function (field_name) {
                //     delete data_set.cache_data[field_name];
                // });
console.log('reset_cache_data data_set deleted',JSON.stringify(data_set.cache_data));
                Object.keys(data_set.cache_data_label).forEach(function (field_name) {
                    delete data_set.cache_data_label[field_name];
                });
                if (!data_set.form_root.item_field[data_set.module_name]) {
                    // current form_root
                    if (current_object.$root.item_field[data_set.module_name]) {
                        data_set.form_root.item_field[data_set.module_name] = {};
                        current_object.$root.set_field(current_object.$root.item_field[data_set.module_name],data_set.form_root.item_field[data_set.module_name]);
                    } else {
                        console.log('Error: reset_cache_data field -> "'+data_set.module_name+'" missing',current_object.$root);
                    }
                }
                Object.keys(data_set.current_item_field).forEach(function (field_name) {
                    delete data_set.current_item_field[field_name];
                });
                current_object.$root.set_field(data_set.form_root.item_field[data_set.module_name],data_set.current_item_field);
                // Reset cache_data and cache_data_label by data_set.form_root.item_field
                Object.keys(data_set.current_item_field).forEach(function (field_name) {
                    if (Array.isArray(data_set.cache_data[field_name])) {
                        data_set.cache_data[field_name].splice(0, data_set.cache_data[field_name].length);
                        if (Array.isArray(data_set.current_item_field[field_name].default_value)) {
                            data_set.current_item_field[field_name].default_value.forEach(function (default_value_item) {
                                data_set.cache_data[field_name].push(JSON.parse(JSON.stringify(default_value_item)));
                            })
                        }
                    } else {
                        if (typeof data_set.current_item_field[field_name].default_value !== 'undefined') {
                            if (typeof data_set.current_item_field[field_name].default_value === 'object' && data_set.current_item_field[field_name].default_value !== null) {
                                data_set.cache_data[field_name] = JSON.parse(JSON.stringify(data_set.current_item_field[field_name].default_value));
                            } else {
                                data_set.cache_data[field_name] = data_set.current_item_field[field_name].default_value;
                            }
                        } else {
                            data_set.cache_data[field_name] = '';
                        }
                    }
                    switch (field_name) {
                        case 'user_id':
                            if (current_object.$root.current_id.user) {
                                data_set.cache_data[field_name] = current_object.$root.current_id.user;
                            }
                            if (current_object.$root.panel === 'admin') {
                                data_set.current_item_field[field_name].display_name = 'Applicant';
                                data_set.current_item_field[field_name].field_type = 'select';
                                data_set.current_item_field[field_name].field_available_options = [];
                                data_set.current_item_field[field_name].empty_value = 0;
                                current_object.$root.item_list.user.forEach(function (user) {
                                    data_set.current_item_field[field_name].field_available_options.push({id:user.id,name:user.long_name});
                                });
                            }
                            break;
                        // case 'parent_id':
                        //     let option_id_list = [];
                        //     if (current_object.current_id) {
                        //         data_set.current_item_field[field_name].field_available_options.forEach(function (option_row, option_row_index) {
                        //             if (current_object.current_id.toString() === option_row.id.toString()) {
                        //                 data_set.current_item_field[field_name].field_available_options.splice(option_row_index,1);
                        //             }
                        //             option_id_list.push(option_row.id.toString());
                        //         });
                        //     }
                        //     if (data_set.form_root.item_list[data_set.module_name]) {
                        //         data_set.form_root.item_list[data_set.module_name].forEach(function (cached_item_row) {
                        //             if (cached_item_row.deleted) {
                        //                 return;
                        //             }
                        //             if (option_id_list.indexOf(cached_item_row.id.toString()) === -1) {
                        //                 data_set.current_item_field[field_name].field_available_options.push({id:cached_item_row.id,name:cached_item_row.display_name});
                        //                 option_id_list.push(cached_item_row.id.toString());
                        //             }
                        //         });
                        //     }
                        //     break;
                    }

                    data_set.current_chosen[field_name] = '';
                    data_set.cache_data_label[field_name] = data_set.current_item_field[field_name].display_name;
                    if (data_set.current_item_field[field_name].validate_type) {
                        if (data_set.current_item_field[field_name].validate_type.indexOf('repeat') >= 0) {
                            if (root.panel === 'admin') {
                                // Never make repeat validation in admin panel
                                data_set.current_item_field[field_name].validate_type.splice(data_set.current_item_field[field_name].validate_type.indexOf('repeat'),1);
                            } else {
                                data_set.current_item_field['_repeat_'+field_name] = JSON.parse(JSON.stringify(data_set.current_item_field[field_name]));
                                data_set.current_item_field['_repeat_'+field_name].validate_type.splice(data_set.current_item_field['_repeat_'+field_name].validate_type.indexOf('repeat'),1);
                                data_set.current_item_field['_repeat_'+field_name].flag_field = 'validation';
                                data_set.current_item_field['_repeat_'+field_name].display_name = 'Repeat '+data_set.current_item_field['_repeat_'+field_name].display_name;
                                data_set.current_item_field['_repeat_'+field_name].ref_field_name = field_name;

                                data_set.cache_data['_repeat_'+field_name] = data_set.cache_data[field_name];
                                data_set.cache_data_label['_repeat_'+field_name] = data_set.current_item_field['_repeat_'+field_name].display_name;
                            }
                        }
                        if (data_set.current_item_field[field_name].validate_type.indexOf('null_flag') >= 0) {
                            data_set.current_item_field['_flag_'+field_name] = {
                                display_name:'With '+data_set.current_item_field[field_name].display_name,
                                field_type:'checkbox',
                                flag_field:'validation',
                                formatted_content:{
                                    0:'Without '+data_set.current_item_field[field_name].display_name,
                                    1:'With '+data_set.current_item_field[field_name].display_name,
                                },
                                name:'_flag_'+field_name,
                                ref_field_name: field_name,
                            };
                            data_set.cache_data['_flag_'+field_name] = false;
                            if (data_set.cache_data[field_name]) {
                                data_set.cache_data['_flag_'+field_name] = true;
                            }
                            data_set.cache_data_label['_flag_'+field_name] = data_set.current_item_field['_flag_'+field_name].display_name;
                        }
                    }
                    if (data_set.current_item_field[field_name].field_available_options) {
                        if (!data_set.field_available_options[field_name]) {
                            data_set.field_available_options[field_name] = [];
                        }
                        console.log('data_set.item_field',data_set.item_field,field_name,data_set.current_item_field[field_name].field_available_options);
                        current_object.set_to_list(data_set.field_available_options[field_name], data_set.current_item_field[field_name].field_available_options);
                    }
//                     if (data_set.current_item_field[field_name].field_type === 'multi_checkbox') {
// console.log('test point 1 data_set.current_item_field[field_name]');
//
//                         if (typeof data_set.cache_data['_flag_'+field_name] === 'undefined') {
//                             data_set.cache_data['_flag_'+field_name] = {};
//                         }
//                         data_set.current_item_field[field_name].field_available_options.forEach(function (field_available_option) {
//                             data_set.current_item_field['_flag_'+field_name+'_'+field_available_option.id] = {
//                                 display_name:data_set.current_item_field[field_name].display_name,
//                                 field_type:'checkbox',
//                                 flag_field:'validation',
//                                 formatted_content:{
//                                     0:'Without '+data_set.current_item_field[field_name].display_name,
//                                     1:'With '+data_set.current_item_field[field_name].display_name,
//                                 },
//                                 name:'_flag_'+field_name,
//                                 ref_field_name: field_name,
//                             };
//                             data_set.cache_data['_flag_'+field_name][field_available_option.id] = false;
//                         });
// console.log('test point 2 data_set.current_item_field[field_name]',JSON.stringify(data_set.cache_data));
//                     }

                    if (data_set.current_item_field[field_name].field_type === 'select') {
                        switch (field_name) {
                            case 'type':
                                if (data_set.module_name === 'fte_review_entity') {
                                    if (data_set.module_depth_level <= 1) {
                                        data_set.current_item_field[field_name].field_available_options.splice(0, data_set.current_item_field[field_name].field_available_options.length);
                                        data_set.form_root.item_field[data_set.module_name][field_name].field_available_options.forEach(function (field_available_option) {
                                            if (field_available_option.id !== 'Individual') {
                                                data_set.current_item_field[field_name].field_available_options.push({id:field_available_option.id,name:field_available_option.name});
                                            }
                                        });
                                    } else {
                                        if (data_set.module_depth_level >= 10) {
                                            data_set.current_item_field[field_name].field_available_options.splice(0, data_set.current_item_field[field_name].field_available_options.length);
                                            data_set.form_root.item_field[data_set.module_name][field_name].field_available_options.forEach(function (field_available_option) {
                                                if (['Family Trust','Individual'].includes(field_available_option.id)) {
                                                    data_set.current_item_field[field_name].field_available_options.push({id:field_available_option.id,name:field_available_option.name});
                                                }
                                            });
                                        }
                                    }
                                }
                                break;
                            case 'fte_individual_id':
                            case 'iee_individual_id':
                                if (current_object.form_root && current_object.form_root.item_map && current_object.form_root.item_map.fte_review_individual && current_object.form_root.cache_data && current_object.form_root.cache_data.fte_review_individuals) {
                                    data_set.current_item_field[field_name].field_available_options.splice(0, data_set.current_item_field[field_name].field_available_options.length);
                                    current_object.form_root.cache_data.fte_review_individuals.forEach(function (fte_review_individual_id) {
                                        data_set.current_item_field[field_name].field_available_options.push({id:fte_review_individual_id,name:current_object.form_root.item_map.fte_review_individual[fte_review_individual_id].name})
                                    })
                                }
                                break;
                            default:

                        }
                    }
                });
                Object.keys(data_set.cache_data).forEach(function (field_name) {
                    if (typeof data_set.cache_data_label[field_name] === 'undefined') {
                        delete data_set.cache_data[field_name];
                    }
                });
                if (data_set.current_item_field[data_set.form_root.module_name+'_id']) {
                    data_set.cache_data[data_set.form_root.module_name+'_id'] = '';
                    if (current_object.$parent.current_item_id) {
                        data_set.cache_data[data_set.form_root.module_name+'_id'] = current_object.$parent.current_item_id;
                        data_set.current_item_field[data_set.form_root.module_name+'_id'].field_type = 'hidden';
                    }
                }

                data_set.component_controllers.splice(0, data_set.component_controllers.length);
                let component_controllers = ['cancel'];
                if (data_set.component_action !== 'view') {
                    component_controllers.unshift('submit');
                }
                if (option.component_controllers) {
                    component_controllers = option.component_controllers;
                }
                component_controllers.forEach(function (component_controller) {
                    let default_option = {};
                    if (typeof component_controller === 'string') {
                        component_controller = {name:component_controller};
                    }
                    if (component_controller.name) {
                        default_option.label = current_object.$root.fix_format(component_controller.name,['display_name']);
                        default_option.action = current_object[component_controller.name];           // e.g. edit_item, delete_item
                        default_option.show_controller = true;
                        default_option.style_class = 'btn btn-primary';

                        switch (component_controller.name) {
                            // case 'delete':
                            //     default_option.icon_class = 'glyphicon glyphicon-trash';
                            //     break;
                            case 'cancel':
                                if (data_set.component_action == 'view') {
                                    default_option.label = 'Back';
                                } else {
                                    default_option.style_class = 'btn btn-secondary-inverse';
                                }
                                // default_option.icon_class = 'glyphicon glyphicon-remove';
                                break;
                            case 'submit':
                                // default_option.icon_class = 'glyphicon glyphicon-ok';
                                break;
                            case 'revise':
                                default_option.style_class = 'btn btn-secondary-inverse';
                                default_option.label = 'Back';
                                // default_option.icon_class = 'glyphicon glyphicon-chevron-left';
                                break;
                            case 'confirm':
                                default_option.label = 'Next';
                                // default_option.icon_class = 'glyphicon glyphicon-chevron-right';
                                break;
                            default:
                            // default_option.icon_class = 'glyphicon glyphicon-asterisk component_controller_'+component_controller.name;
                        }
                    }
                    component_controller = Object.assign(default_option,component_controller);
                    if (!current_object[component_controller.name]) {
                        current_object[component_controller.name] = function () {
                            return false;
                        }
                    }
                    data_set.component_controllers.push(component_controller);
                });
                console.log('UpdateSubItem current_id',data_set.current_id,data_set.module_name,current_object.current_id);
                if (data_set.current_id && data_set.current_id !== 'new') {
                    if (!data_set.form_root.item_map[data_set.module_name][data_set.current_id]) {
                        if (current_object.$root.item_map[data_set.module_name][data_set.current_id]) {
                            data_set.form_root.item_map[data_set.module_name][data_set.current_id] = current_object.$root.import_item(current_object.$root.item_map[data_set.module_name][data_set.current_id]);

                            // current_object.current_item_field[field_name].field_available_options.forEach(function (field_available_option) {
                            //     current_object.cache_data['_flag_'+field_name+'_'+field_available_option.id] = false;
                            // });
                            // new_value.forEach(function (new_value_item) {
                            //     new_value_item = new_value_item.trim();
                            //     current_object.cache_data['_flag_'+field_name+'_'+new_value_item] = true;
                            //     current_object.cache_data[field_name].push(new_value_item);
                            // });
                        } else {
                            console.log('Error: '+data_set.module_name+' -> '+data_set.current_id+' does not exist in form_root->item_map or $root->item_map',data_set.form_root.item_map,current_object.$root.item_map);
                        }
                    }
                    if (data_set.form_root.item_map[data_set.module_name][data_set.current_id]) {
                        let item_map_item = data_set.form_root.item_map[data_set.module_name][data_set.current_id];
                        Object.keys(data_set.cache_data).forEach(function (field_name) {
                            switch (typeof item_map_item[field_name]) {
                                case 'boolean':
                                    data_set.cache_data[field_name] = item_map_item[field_name]?'1':'0';
                                    break;
                                case 'number':
                                    data_set.cache_data[field_name] = item_map_item[field_name].toString();
                                    break;
                                case 'string':
                                    data_set.cache_data[field_name] = item_map_item[field_name];
                                    break;
                                case 'object':
                                    if (Array.isArray(item_map_item[field_name])) {
                                        if (!data_set.cache_data[field_name]) {
                                            data_set.cache_data[field_name] = [];
                                        } else {
                                            data_set.cache_data[field_name].splice(0, data_set.cache_data[field_name].length);
                                        }
                                    } else {
                                        if (!data_set.cache_data[field_name]) {
                                            data_set.cache_data[field_name] = {};
                                        } else {
                                            Object.keys(data_set.cache_data[field_name]).forEach(function (key) {
                                                delete data_set.cache_data[field_name][key];
                                            })
                                        }
                                    }
                                    data_set.cache_data[field_name] = Object.assign(data_set.cache_data[field_name], JSON.parse(JSON.stringify(item_map_item[field_name])));
                                    break;
                                case 'undefined':
                                    break;
                                default:
                                    // unexpected value type
                                    console.log('unexpected typeof value from form_root.item_map -> '+data_set.module_name+' -> '+field_name, item_map_item[field_name]);

                            }
                            if (data_set.current_item_field[field_name].field_type === 'sub_item_list') {
                                if (!data_set.cache_data[field_name]) {
                                    data_set.cache_data[field_name] = [];
                                } else {
                                    data_set.cache_data[field_name].splice(0, data_set.cache_data[field_name].length);
                                }
                                if (data_set.current_item_field[field_name].ref_module_name && data_set.form_root.item_list[data_set.current_item_field[field_name].ref_module_name]) {
                                    data_set.form_root.item_list[data_set.current_item_field[field_name].ref_module_name].forEach(function (sub_item) {
                                        if (sub_item.parent_id === data_set.current_id) {
                                            data_set.cache_data[field_name].push(sub_item.id);
                                        }
                                    });
                                }
                            }
                            console.log('test point 3 data_set.current_item_field[field_name]',field_name,data_set.current_item_field,data_set.current_item_field[field_name]);
                            // if (data_set.current_item_field[field_name] && data_set.current_item_field[field_name].field_type === 'multi_checkbox' && Array.isArray(data_set.cache_data[field_name])) {
                            //
                            //     // data_set.current_item_field[field_name].field_available_options.forEach(function (field_available_option) {
                            //     //     data_set.cache_data['_flag_'+field_name+'_'+field_available_option.id] = false;
                            //     // });
                            //     data_set.cache_data[field_name].forEach(function (selected_id) {
                            //         if (typeof data_set.cache_data['_flag_'+field_name][selected_id] !== 'undefined') {
                            //             data_set.cache_data['_flag_'+field_name][selected_id] = true;
                            //         }
                            //     });
                            // }
                        });

                    }
                }
                current_object.get_available_fields(data_set);
            },

            /*field_available_options: function(field_name, module_name) {
                let current_object = this;
                let current_item_field;
                let result = [];
                if (typeof module_name === 'undefined') {
                    module_name = current_object.module_name;
                    current_item_field = current_object.current_item_field;
                } else {
                    if (current_object.form_root && current_object.form_root.item_field && current_object.form_root.item_field[module_name]) {
                        current_item_field = current_object.form_root.item_field[module_name];
                    }
                }
console.log('field_available_options()',field_name,current_item_field,current_item_field[field_name].field_available_options);
                switch (field_name) {
                    case 'fte_individual_id':
                    case 'iee_individual_id':
                        console.log('current_object.form_root',field_name,current_object.form_root,current_object.form_root && current_object.form_root.item_map,current_object.form_root.item_map.fte_review_individual,current_object.form_root.cache_data,current_object.form_root.cache_data.fte_review_individuals);
                        if (current_object.form_root && current_object.form_root.item_map && current_object.form_root.item_map.fte_review_individual && current_object.form_root.cache_data && current_object.form_root.cache_data.fte_review_individuals) {
                            current_object.form_root.cache_data.fte_review_individuals.forEach(function (fte_review_individual_id) {
                                result.push({id:fte_review_individual_id,name:current_object.form_root.item_map.fte_review_individual[fte_review_individual_id].name})
                            })
                        }
                        return result;
                        break;
                    case 'years_active_as_child':
                        console.log('current_object.form_root',field_name,current_object.form_root,current_object.form_root && current_object.form_root.item_map,current_object.form_root.item_map.fte_review_individual,current_object.form_root.cache_data,current_object.form_root.cache_data.fte_review_individuals);
                        // if (current_object.form_root && current_object.form_root.cache_data && current_object.form_root.cache_data.distribution_years) {
                        //     current_object.form_root.cache_data.distribution_years.forEach(function (distribution_year) {
                        //         result.push({id:distribution_year,name:distribution_year,checked:current_object.cache_data[field_name].includes(distribution_year)});
                        //     })
                        // }
                        if (current_item_field[field_name].field_available_options) {
                            current_object.cache_data
                            current_item_field[field_name].field_available_options.forEach(function (field_available_option) {
                                result.push({id:field_available_option.id,name:field_available_option.name});
                            })
                        }
                        return result;
                        break;
                    default:
                        return current_item_field[field_name].field_available_options;

                }

            },*/

            get_available_fields: function (data_set) {
                let current_object = this;
                if (typeof data_set === 'undefined') {
                    data_set = current_object;
                }
                data_set.available_fields.splice(0,data_set.available_fields.length);
                if (data_set.current_item_field) {
                    Object.keys(data_set.current_item_field).forEach(function (field_name) {
                        if (['fillable','reference_list','image_data'].indexOf(data_set.current_item_field[field_name].flag_field) >= 0 ) {
                            if (data_set.component_action !== 'view') {
                                if (['id','created_at','updated_at'].indexOf(field_name) >= 0 ) {
                                    return;
                                }
                                // diagram_positions is internal layout state, never edited in the form.
                                if (field_name === 'diagram_positions') {
                                    return;
                                }
                                if (field_name === 'years_active_as_child') {
                                    if (!current_object.$parent || current_object.$parent.module_name !== 'fte_review_entity') {
                                        return;
                                    }
                                }
                                if (['name','fte_individual_id','fte_year','iee_individual_id','iee_year','fte_review_sub_entities'].indexOf(field_name) >= 0 ) {
                                    switch (data_set.cache_data.type) {
                                        case 'Individual':
                                            if (['fte_individual_id'].indexOf(field_name) < 0 ) {
                                                return;
                                            }
                                            break;
                                        case 'Company':
                                        case 'Unit Trust':
                                            if (['name','fte_review_sub_entities'].indexOf(field_name) < 0 ) {
                                                return;
                                            }
                                            break;
                                        case 'Family Trust':
                                            if (['fte_review_sub_entities'].indexOf(field_name) >= 0 ) {
                                                return;
                                            }
                                            break;
                                        default:
                                            return;

                                    }
                                }

                            }
                            data_set.available_fields.push(field_name);
                        }
                    });
                }
            },

            read_file: function (file, field) {
                var error_message= '';
                let current_object = this;

                if (!file) {
                    console.log('Error, empty file input');
                    return;
                }

                if(!file.type)
                {
                    console.log('Unknown type of file');
                    return;
                }

                var reader = new FileReader();

                // When it's loaded, we'll assign the read section to a variable (bg_img);
                reader.onload = function(event){
                    current_object.cache_data[field] = event.target.result;
                };

                // Pass the reader the file to read and give us the DataURL
                console.log('allen debug read_file',file);
                reader.readAsDataURL(file);
            },

//             multi_checkbox_checked: function(field_name, field_option_id) {
//                 let current_object = this;
// console.log('multi_checkbox_checked',field_name,field_option_id,current_object.cache_data[field_name].indexOf(field_option_id));
//                 return current_object.cache_data[field_name].indexOf(field_option_id) > -1
//             },

            field_change: function(field_name, value, option) {
                let current_object = this;
                if (typeof option === 'undefined') {
                    option = {};
                }
                // if (current_object.$root.panel !== 'admin') {
                //     if (['fte_review_entity','loan_agreement','register_company','super','trust'].indexOf(current_object.module_name) > -1 && ['type','variation'].indexOf(field_name) > -1) {
                //         if (typeof value !== 'undefined') {
                //             let query_object = {};
                //             query_object['type'] = current_object.cache_data.type;
                //             query_object[field_name] = value;
                //             current_object.$root.set_page(location.pathname,query_object);
                //             return ;
                //         }
                //     }
                // } else {
                //     if (['fte_review_entity','loan_agreement','register_company','super','trust'].indexOf(current_object.module_name) > -1 && ['type','variation'].indexOf(field_name) > -1) {
                //         current_object.get_available_fields();
                //     }
                // }
                // By default, if value is not provided, do not do anything. Override function from current_page.component_methods (in $root, app.js)
                if (typeof value !== 'undefined' && typeof current_object.cache_data[field_name] !== 'undefined') {
                    let set_method = option.set_method;
                    if (typeof set_method === 'undefined') {
                        set_method = 'default';
                    }
                    if (Array.isArray(current_object.cache_data[field_name])) {
                        // add, remove, inverse methods are for array type variables
                        switch (set_method) {
                            case 'add':
                                current_object.add_to_list(value, current_object.cache_data[field_name]);
                                break;
                            case 'remove':
                                current_object.remove_from_list(value, current_object.cache_data[field_name]);
                                break;
                            case 'toggle':
                                current_object.toggle_list(value, current_object.cache_data[field_name]);
                                break;
                            case 'overwrite':
                            default:
                                let new_value = value;

                                if (typeof new_value === 'string') {
                                    new_value = new_value.split(',');
                                }
                                current_object.set_to_list(current_object.cache_data[field_name], new_value);
                        }
                        // current_object.$root.$forceUpdate();
                    } else {
                        current_object.cache_data[field_name] = value;
                    }
                } else {
                    if (current_object.current_item_field && current_object.current_item_field[field_name]) {
                        let current_field = current_object.current_item_field[field_name];
                        if (current_object.current_item_field[field_name].field_type === 'file' && current_object.$refs[field_name]) {
                            current_object.read_file(current_object.$refs[field_name].files[0], field_name);
                            // current_object.cache_data[field_name] = current_object.$refs[field_name].files[0];
                        }
                        // if (current_field.field_type) {
                        //     switch (current_field.field_type) {
                        //         case 'multi_checkbox':
                        //             // if (typeof value !== 'undefined') {
                        //             //     let new_value = value;
                        //             //
                        //             //     if (typeof new_value === 'string') {
                        //             //         new_value = new_value.split(',');
                        //             //     }
                        //             //     current_object.cache_data[field_name].splice(0, current_object.cache_data[field_name].length);
                        //             //     new_value.forEach(function (new_value_item) {
                        //             //         new_value_item = new_value_item.trim();
                        //             //         current_object.cache_data['_flag_'+field_name+'_'+new_value_item] = true;
                        //             //         current_object.cache_data[field_name].push(new_value_item);
                        //             //     });
                        //             // } else {
                        //             //     console.log('current_object.cache_data[field_name]',field_name,current_object.cache_data[field_name]);
                        //             //     current_object.cache_data[field_name].splice(0, current_object.cache_data[field_name].length);
                        //             //     current_object.current_item_field[field_name].field_available_options.forEach(function (field_available_option) {
                        //             //         if (current_object.cache_data['_flag_'+field_name+'_'+field_available_option.id]) {
                        //             //             current_object.cache_data[field_name].push(field_available_option.id);
                        //             //         }
                        //             //     });
                        //             // }
                        //             // current_object.cache_data[field_name].splice(0,current_object.cache_data[field_name].length);
                        //             // current_object.current_item_field[field_name].field_available_options.forEach(function (field_available_option) {
                        //             //     if (current_object.cache_data['_flag_'+field_name][field_available_option.id]) {
                        //             //         console.log('current_object.cache_data[\'_flag_\'+field_name][field_available_option.id]',field_available_option.id);
                        //             //         current_object.cache_data[field_name].push(field_available_option.id);
                        //             //     }
                        //             // });
                        //             // break;
                        //
                        //     }
                        // }
                    }
                }
                switch (field_name) {
                    case 'type':
                        current_object.get_available_fields();
                        break;

                }
console.log('field_change',field_name,value,option,JSON.stringify(current_object.cache_data[field_name]),current_object.cache_data[field_name].indexOf(value));

                if (typeof current_object._field_change === 'function') {
                    return current_object._field_change(field_name);
                }
                return true;
            },

            field_label: function(field_name,label_type) {
                let current_object = this;

                if (!field_name || !current_object.cache_data_label[field_name]) {
                    return '';
                }

                if (typeof label_type === 'undefined') {
                    label_type = 'label';
                }

                let result = current_object.cache_data_label[field_name];

                if (current_object.module_name === 'fte_review_entity') {
                    switch (field_name) {
                        case 'fte_individual_id':
                            switch (current_object.cache_data.type) {
                                case 'Family Trust':
                                    result = 'Fte Individual';
                                    break;
                                default:
                                    result = 'Individual Name';
                            }
                            break;
                        case 'fte_review_sub_entities':
                            switch (current_object.cache_data.type) {
                                case 'Company':
                                    result = 'Shareholders';
                                    break;
                                case 'Unit Trust':
                                    result = 'Unitholders';
                                    break;
                                default:
                                    result = 'Members'
                            }
                            break;
                        case 'name':
                            switch (current_object.cache_data.type) {
                                case 'Company':
                                    result = 'Company Name';
                                    break;
                                case 'Family Trust':
                                case 'Unit Trust':
                                    result = 'Trust Name';
                                    break;
                                default:
                                    result = 'Name';
                            }
                            break;
                        case 'years_active_as_child':
                            switch (current_object.$parent.cache_data.type) {
                                case 'Company':
                                    result = 'Years active as Shareholder';
                                    break;
                                case 'Unit Trust':
                                    result = 'Years active as Unitholder';
                                    break;
                                default:
                                    result = 'Years active as Members'
                            }
                            break;
                    }
                }


                switch (label_type) {
                    case 'confirmation':
                        if (field_name.match(/_eq$/)) {
                            result = result.replace('Evenly Divided','Distribution');
                        }
                        break;
                    case 'placeholder':
                        if (current_object.mandatory_fields.indexOf(field_name) === -1 && !/^_/.test(field_name)) {
                            result += ' (optional)';
                        }
                        break;
                    case 'select_default':
                        result = '-- '+result+' --';
                        break;
                    case 'select_undefined':
                        result = '-- No '+result+' --';
                        break;
                    case 'label':
                    default:
                }
                return  result;
            },

            field_validation: function(field) {

            },

            formatted_field_value: function(field_name, item_field) {
                let current_object = this;
                let current_value = current_object.cache_data[field_name];
                if (typeof item_field === 'undefined') {
                    item_field = current_object.current_item_field;
                }
                if (current_object.cache_data['type'] === 'ST' && field_name.match(/_eq$/)) {
// console.log('allen debug formatted_field_value',field_name,current_value,typeof current_value);
                    let distribution_type = field_name.replace(/_eq$/,'');
                    let distribution_display_content = 'N/A';
                    if (current_value == '1') {
                        distribution_display_content = 'Evenly distributed';
                    } else {
                        if (current_value == '0') {
                            distribution_display_content = '';
                            if (typeof current_object.cache_data[distribution_type+'_proportion'] !== 'undefined') {
                                distribution_display_content += 'Surviving Parent ('+current_object.cache_data[distribution_type+'_proportion']+'%)';
                            }
                            current_object.cache_data['beneficiary_child'].forEach(function (party_id) {
                                if (distribution_display_content) {
                                    distribution_display_content += ', ';
                                }
                                distribution_display_content += current_object.form_root.item_map[current_object.module_name + '_party'][party_id].formatted_name+' ('+current_object.form_root.item_map[current_object.module_name + '_party'][party_id][distribution_type+'_proportion']+'%)';
                            });
                        }
                    }
                    return distribution_display_content;
                }
                if (item_field[field_name]) {
                    let current_field = item_field[field_name];
                    if (current_field.formatted_content && field_name !== 'address_id') {
                        if (typeof current_field.formatted_content === 'function') {
                            return current_field.formatted_content(current_value);
                        }
                        if (typeof current_field.formatted_content === 'object') {
                            return current_field.formatted_content[current_value];
                        }
                    } else {
                        if (current_field.ref_name && current_object.form_root.item_map[current_field.ref_name] !== current_field._ref) {
                            current_field._ref = current_object.form_root.item_map[current_field.ref_name];
                        }
                        if (current_field._ref) {
                            if (current_field._ref[current_value]) {
                                if (current_field._ref[current_value].formatted_name) {
                                    return current_field._ref[current_value].formatted_name;
                                }
                                if (current_field._ref[current_value].formatted_address) {
                                    return current_field._ref[current_value].formatted_address;
                                }
                                if (current_field._ref[current_value].name) {
                                    return current_field._ref[current_value].name;
                                }
                            } else {
                                return 'N/A';
                            }
                        }
                        if (current_field.field_available_options) {
// console.log('allen debug current_field.field_available_options',current_field.field_available_options,current_value);
                            for (let i=0;i<current_field.field_available_options.length;i++) {
                                if (current_field.field_available_options[i].id === current_value) {
                                    return current_field.field_available_options[i].name;
                                }
                            }
                        }
                    }

                }
                return current_value;

            },

            show_input: function(field_name) {
                let current_object = this;
                /*switch (field_name) {
                    case 'fte_individual_id':
                    case 'fte_year':
                    case 'iee_individual_id':
                    case 'iee_year':
                        console.log('current_object.cache_data.type',current_object.cache_data.type,field_name);
                        return (current_object.cache_data.type === 'Family Trust');
                        break;
                    case 'years_active_as_child':
                        console.log('current_object.cache_data.type',current_object.cache_data.type,field_name,['Company','Unit Trust'].indexOf(current_object.cache_data.type) > -1);
                        return (['Company','Unit Trust'].indexOf(current_object.cache_data.type) > -1);
                        break;

                }*/
                return true;
            },

            show_label: function(field_name) {
                let current_object = this;
                if (typeof current_object.cache_data[field_name] === 'undefined' || typeof current_object.current_item_field[field_name] === 'undefined') {
                    // console.log('show_label failed, field_name does not exist in cache_data and/or item_field',field_name,current_object.cache_data,current_object.item_field);
                    return false;
                }
                let result = 1;
                switch (current_object.current_item_field[field_name].field_type) {
                    case 'checkbox':
                    case 'date':
                    case 'radio':
                    case 'subform':
                    case 'subform_multi':
                        break;
                    default:
                        // if (field_name == 'description') {
                        //     return 1;
                        // }
                        result = (current_object.cache_data[field_name] !== '');

                }
                // console.log('show_label result',field_name,current_object.current_item_field[field_name].field_type,result);
                return result;
            },

            // show_input: function(field_name) {
            //     let current_object = this;
            //
            //     return current_object.available_fields().indexOf(field_name)>-1;
            // },
            set_to_list: function (list, source_list) {
                list.splice(0,list.length);
                source_list.forEach(function (item) {
                    list.push(item);
                });
            },
            add_to_list: function (item, list) {
                let index = list.indexOf(item);
                if (index === -1) {
                    list.push(item);
                }
            },
            remove_from_list: function (item, list) {
                let index = list.indexOf(item);
                if (index > -1) {
                    list.splice(index,1);
                }
            },
            toggle_list: function (item, list) {
                let index = list.indexOf(item);
                if (index > -1) {
                    list.splice(index,1);
                } else {
                    list.push(item);
                }
            },

            get_current_chosen: function () {
                let current_object = this;
                let result = [];
                Object.keys(current_object.current_chosen).forEach(function (field_name) {
                    if (current_object.current_chosen[field_name]) {
                        result.push(field_name);
                    }
                });
                return result;
            },

            set_current_chosen: function (chosen_field_name, chosen_value) {
                if (typeof chosen_value === 'undefined') {
                    chosen_value = 1;
                }
                let current_object = this;
                Object.keys(current_object.current_chosen).forEach(function (field_name) {
                    if (field_name === chosen_field_name) {
                        current_object.current_chosen[field_name] = chosen_value;
                    }
                    // else {
                    //     current_object.current_chosen[field_name] = '';
                    // }
                })
            },

            subform_submit: function (item_id, field_name, subform_action) {
                // console.log('allen debug subform_submit',item_id,field_name,subform_action);
                let current_object = this;
console.log(field_name, current_object.current_chosen, current_object.current_chosen[field_name]);
                current_object.current_chosen[field_name] = '';

                if (typeof subform_action === 'undefined') {
                    subform_action = 'submit';     // By default, action submit is called
                }

                if (subform_action === 'cancel') {
                    return true;
                }

                if (subform_action === 'reset') {
                    if (typeof current_object.current_item_field[field_name].default_value !== 'undefined' && current_object.current_item_field[field_name].default_value !== null) {
                        if (typeof current_object.current_item_field[field_name].default_value === 'object') {
                            current_object.cache_data[field_name] = JSON.parse(JSON.stringify(current_object.current_item_field[field_name].default_value));
                        } else {
                            current_object.cache_data[field_name] = current_object.current_item_field[field_name].default_value;
                        }
                    } else {
                        current_object.cache_data[field_name] = '';
                    }
                    return true;
                }
console.log('test point 2',current_object.current_item_field[field_name],field_name,current_object.current_item_field);
                if (current_object.current_item_field[field_name].flag_field === 'reference_list') {
                    let reference_module_name = current_object.current_item_field[field_name].ref_module_name;
                    if (!reference_module_name) {
                        reference_module_name = 'fte_review_entity';
                    }
                    if (!item_id) {
                        return false;
                    }
console.log('test point 3',item_id,reference_module_name,current_object.form_root.item_map);
                    let sub_item = current_object.form_root.item_map[reference_module_name][item_id];
                    // console.log('allen debug update_attached_trust_party',item_id,field_name,trust_party,current_object.current_chosen,current_object);
console.log('test point 4');
                    if (!sub_item) {
                        current_object.message_option.message = ['Invalide item_id: ',item_id];
                        current_object.message_option.message_type = 'error';
                        return false;
                    }

                    if (current_object.cache_data[field_name].indexOf(item_id) === -1) {
                        current_object.cache_data[field_name].push(item_id);
                    }
                } else {
                    current_object.cache_data[field_name] = item_id;
                }
console.log('test point 5',current_object.cache_data,current_object.current_chosen[field_name]);
            },

            form_validation: function () {
                let current_object = this;
                let warning_message = [];

                // General Validation, e.g. mandatory field empty, number format wrong...
                current_object.available_fields.forEach(function (field_name) {
                    if (field_name === 'interest') {
                        if (['WI', 'WIW'].indexOf(current_object.cache_data.variation) === -1) {
                            current_object.cache_data[field_name] = 0;
                            return;
                        }
                    }
                    if (current_object.mandatory_fields.includes(field_name) && current_object.cache_data[field_name] === '') {
                        warning_message.push('"'+current_object.cache_data_label[field_name]+'" is required.');
                    }
// console.log('allen debug current_object.current_item_field[field_name].validate_type',field_name,current_object.cache_data[field_name],current_object.current_item_field[field_name],current_object.available_fields,current_object.current_item_field);
                    if (current_object.cache_data[field_name] !== '' && current_object.current_item_field[field_name].validate_type) {
                        // Normally, do not do pattern check if the field is empty
                        if (current_object.current_item_field[field_name].validate_type.indexOf('email') >= 0) {
                            var reg_pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            if (!reg_pattern.test(current_object.cache_data[field_name]))
                            {
                                warning_message.push(''+current_object.cache_data_label[field_name]+' is not valid. E.g. john@gmail.com');
                            }
                        }
                        if (current_object.current_item_field[field_name].validate_type.indexOf('none_space') >= 0) {
                            var reg_pattern = /(\s+)/;
                            if (reg_pattern.test(current_object.cache_data[field_name]))
                            {
                                warning_message.push(''+current_object.cache_data_label[field_name]+' cannot contain spaces');
                            }
                        }
                        if (current_object.current_item_field[field_name].validate_type.indexOf('repeat') >= 0) {
                            if (current_object.cache_data[field_name] && current_object.cache_data[field_name] !== current_object.cache_data['_repeat_'+field_name]) {
                                warning_message.push(''+current_object.cache_data_label['_repeat_'+field_name]+' does not match '+current_object.cache_data_label[field_name]);
                            }
                        }
                        if (current_object.current_item_field[field_name].validate_type.indexOf('null_flag') >= 0) {
                            if (current_object.cache_data['_flag_'+field_name]) {
                                if (!current_object.cache_data[field_name]) {
                                    warning_message.push('"'+current_object.cache_data_label[field_name]+'" is required.');
                                }
                            } else {
                                current_object.cache_data[field_name] = '';
                            }
                        }
                    }

                    if (current_object.current_item_field[field_name] && current_object.current_item_field[field_name].limit) {
                        if (current_object.cache_data[field_name].length < current_object.current_item_field[field_name].limit.min) {
                            warning_message.push('Minimum '+current_object.current_item_field[field_name].limit.min+' "'+current_object.cache_data_label[field_name]+'" is required.');
                        }
                        if (current_object.cache_data[field_name].length > current_object.current_item_field[field_name].limit.max) {
                            warning_message.push('Maximum '+current_object.current_item_field[field_name].limit.max+' "'+current_object.cache_data_label[field_name]+'" is allowed.');
                        }
                    }

                    // if (field_name.match(/^repeat_/)) {
                    //     // Special field validation, repeat_xxx fields are confirmation fields, must have consistent value with xxx fields they refer to
                    //     let source_field_name = field_name.replace(/^repeat_/,'');
                    //     if (current_object.cache_data[field_name] && current_object.cache_data[source_field_name] && current_object.cache_data[field_name] !== current_object.cache_data[source_field_name]) {
                    //         warning_message.push(''+current_object.cache_data_label[field_name]+' does not match '+current_object.cache_data_label[source_field_name]);
                    //     }
                    // }
                });

                // return warning_message;
                if (warning_message.length > 0) {
                    current_object.message_option.message = warning_message;
                    current_object.message_option.message_type = 'error';
                    return false;
                } else {
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }
                return true;
            },

            submit: function (event) {
                // TODO: if store_for_future checked, post stored data to server

                event.preventDefault();

                let current_object = this;
console.log('submit current_object.cache_data',JSON.stringify(current_object.cache_data));
                if (!current_object.form_validation()) {
console.log('Form validation failed',current_object,current_object.module_name);
                    return false;
                }
                let current_item = {};
                if (current_object.current_id && current_object.form_root.item_map[current_object.module_name][current_object.current_id]) {
                    current_item = current_object.form_root.item_map[current_object.module_name][current_object.current_id];
                } else {
                    let index_counter = 1;
                    while (current_object.form_root.item_map[current_object.module_name]['new_'+index_counter]) {
                        index_counter++;
                    }
                    current_item.id = 'new_'+index_counter;

                    current_object.form_root.item_map[current_object.module_name][current_item.id] = current_item;
                    current_object.form_root.item_list[current_object.module_name].push(current_item);
                    // current_object.current_id = current_item.id;
                }
console.log('test point 1',JSON.stringify(current_object.cache_data));
                // current_item = Object.assign(current_item,current_object.cache_data);
                current_object.available_fields.forEach(function (field_name) {
                    if (current_object.current_item_field[field_name].flag_field === 'reference_list') {
                        let reference_module_name = current_object.current_item_field[field_name].ref_module_name;
                        if (!reference_module_name) {
                            reference_module_name = 'fte_review_entity';
                        }
                        if (current_object.form_root.item_map[reference_module_name]) {
                            if (reference_module_name === current_object.module_name) {
                                current_object.cache_data[field_name].forEach(function (sub_item_id) {
                                    if (typeof current_object.form_root.item_map[reference_module_name][sub_item_id]['parent_id'] !== 'undefined') {
                                        current_object.form_root.item_map[reference_module_name][sub_item_id]['parent_id'] = current_item.id;
                                    }
                                });
                            } else {
                                current_object.cache_data[field_name].forEach(function (sub_item_id) {
                                    if (typeof current_object.form_root.item_map[reference_module_name][sub_item_id][current_object.module_name+'_id'] !== 'undefined') {
                                        current_object.form_root.item_map[reference_module_name][sub_item_id][current_object.module_name+'_id'] = current_item.id;
                                    }
                                });
                            }
                        }
                    } else {
                        if (Array.isArray(current_object.cache_data[field_name])) {
                            if (!Array.isArray(current_item[field_name])) {
                                current_item[field_name] = [];
                            } else {
                                current_item[field_name].splice(0,current_item[field_name].length);
                            }
                            current_object.cache_data[field_name].forEach(function (cache_item) {
                                current_item[field_name].push(JSON.parse(JSON.stringify(cache_item)));
                            });
                        } else {
                            if (current_object.cache_data[field_name] && typeof current_object.cache_data[field_name] === 'object') {
                                current_item[field_name] = JSON.parse(JSON.stringify(current_object.cache_data[field_name]));
                            } else {
                                current_item[field_name] = current_object.cache_data[field_name];
                            }
                        }
                    }
                });
console.log('test point 2',JSON.stringify(current_object.cache_data));
console.log('test point 3',JSON.stringify(current_item));

                // fte_review_entity make formatted_name on save
                if (current_object.module_name === 'fte_review_entity') {
                    switch (current_item.type) {
                        case 'Individual':
                            if (current_item.fte_individual_id && current_object.form_root.item_map['fte_review_individual'] && current_object.form_root.item_map['fte_review_individual'][current_item.fte_individual_id]) {
                                current_item.formatted_name = current_object.form_root.item_map['fte_review_individual'][current_item.fte_individual_id].name;
                            }
                            break;
                        case 'Company':
                        case 'Family Trust':
                        case 'Unit Trust':
                        default:
                            current_item.formatted_name = current_item.name
                    }
                }


                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
console.log('allen debug update contact submit',current_item,current_object.form_root.item_map,current_object.form_root.item_list);
                // this.$emit('update:new_contact',this.cache_data.id);
                let field_name_in_parent_form = 'fte_review_entities';
                if (current_object.field_name_in_parent_form) {
                    field_name_in_parent_form = current_object.field_name_in_parent_form;
                }
                current_object.$emit('submit', current_item.id, field_name_in_parent_form, 'submit');
            },
            cancel: function (event) {
                let current_object = this;

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

                // this.$emit('update:new_contact','');
                // $('html, body').stop().animate({
                //     scrollTop:$(current_object.$el).offset().top - 200
                // }, 550);
                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
                let field_name_in_parent_form = current_object.module_name+'_list';
                if (current_object.field_name_in_parent_form) {
                    field_name_in_parent_form = current_object.field_name_in_parent_form;
                }
                // current_object.$emit('submit',current_object.current_party.id?current_object.current_party.id:'',current_object.party_class);
                current_object.$emit('submit', null, field_name_in_parent_form,'cancel');
            }
        },
        watch: {
            current_id: function () {
                let current_object = this;

                console.log('UpdateSubItem current_object.current_id change',current_object,current_object.current_id,$(current_object.$el.parentNode).offset().top,current_object.$el.parentNode.offsetTop);
                current_object.reset_cache_data();

                if (current_object.current_id && $(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    console.log('UpdateTrustParty scrollTop triggered',$(current_object.$el.parentNode).offset().top, current_object,current_object.$el);
                    // $('html, body').stop().animate({
                    //     scrollTop:$(current_object.$el.parentNode).offset().top - 20
                    // }, 550);
                    // $('html, body').scrollTop($(current_object.$el.parentNode).offset().top - 20);

                    $('html, body').stop().animate({
                        scrollTop:$(current_object.$el.parentNode).offset().top - 20
                    }, 550,'swing',function () {
                        $('html, body').scrollTop($(current_object.$el.parentNode).offset().top - 20);
                        console.log('UpdateTrustParty scrollTop 2',$(current_object.$el.parentNode).offset().top,$('html').scrollTop(),$('body').scrollTop(),$('#app').scrollTop());
                    });

                    console.log('UpdateTrustParty scrollTop 1',$(current_object.$el.parentNode).offset().top,$('html').scrollTop(),$('body').scrollTop(),$('#app').scrollTop())
                }

                current_object.message_option.message = '';
                current_object.message_option.message_type = '';
            }
        }
    }
</script>